module.exports = __webpack_public_path__ + "static/assets/2e2d96d059b67ae990ddef7d3aa72ee7.svg";